import "./Loader.css";

/**
 * Loader
 * - Inherits color from parent via `currentColor`
 * - Props: size (px), strokeWidth, label (aria), className
 */
export default function Loader({
  size = 18,
  strokeWidth = 3,
  label = "Loading",
  className = "",
}) {
  return (
    <span className={`loader loader--spin ${className}`} role="status" aria-label={label}>
      <svg
        className="loader__svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="loader__track"
          cx="12"
          cy="12"
          r="10"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
        />
        <path
          className="loader__indicator"
          d="M12 2a10 10 0 0 1 10 10"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
